import styled from 'styled-components';
import { map } from 'styled-components-breakpoint';

import { margins, paddings } from '../ui/utils';

const HeaderLogo = styled.img`
  ${({ width }) => map(width, val => `width: ${val};`)};
  ${({ height }) => map(height, val => `height: ${val};`)};

  ${props => margins(props)};
  ${props => paddings(props)};
`;

export default HeaderLogo;
